import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionService } from '../session-service/session.service';
import { environment } from 'src/environments/environment';
import { API_URL } from '../constants/apiurl-constants';
import { ErrorFileRequest } from 'src/app/survey-insight/survey-creation/models/expense-data-columns-map.model';
import { LoadingIndicatorService } from '@kpmg-tax/ui';
import { FileTypeEnum } from '../constants/file-type.enum';
import { FileImportStatus } from '../models/file-import-status.model';

@Injectable({
  providedIn: 'root'
})
export class FileService {


  constructor(private request: HttpClient, private _sessionService: SessionService, private _loaderService: LoadingIndicatorService) { }

  download(fileName: string): Observable<any> {

    const downloadUrl = environment.envName === '/'
      ? `../assets/${fileName}`
      : `..${environment.envName}assets/${fileName}`

    return this.request.get(downloadUrl, { responseType: 'blob' });
  }

  uploadFile(formData: FormData): Observable<any> {
    const apiPath: string = environment.webApiDefaultRoot + API_URL.UPLOADFILE;
    const headers: HttpHeaders = new HttpHeaders().set('FileUpload', 'true');
    return this.request.post<any>(apiPath, formData, {
      headers: headers, withCredentials: true, reportProgress: true,
      observe: 'events',
    });
  }

  downloadFile(fileId: number, engagementId: number, fileType: number): Observable<Blob> {
    const downloadFileUrl = API_URL.DOWNLOADDATAFILE + '?fileId=' + fileId + '&engagementId=' + engagementId + '&fileType=' + fileType;
    return this._sessionService.downloadAsFileGet(downloadFileUrl);
  }

  isMimeTypeValid(mimeType: any): boolean {
    return (
      mimeType === 'application/vnd.ms-excel' ||
      mimeType === 'text/csv' ||
      mimeType === 'application/json' ||
      mimeType ===
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );
  }
  surveyExport(surveyId: number, engagementId: number) {
    const apiUrl =
      API_URL.SURVEY.DOWNLOADSURVEYDETAILS +
      `?surveyId=${surveyId}&engagementId=${engagementId}`;
    return this._sessionService.downloadAsFileGet(apiUrl);
  }

  saveBlobToFile(blob: Blob, fileName: string): void {
    let url = window.URL || window.webkitURL;
    let link = url.createObjectURL(blob);
    let anchorTag = document.createElement("a");
    anchorTag.setAttribute("download", fileName);
    anchorTag.setAttribute("href", link);
    document.body.appendChild(anchorTag);
    anchorTag.click();
    document.body.removeChild(anchorTag);
  }

  saveBlobToPDFFile(blob: Blob): void {
    let url = window.URL || window.webkitURL;
    let link = url.createObjectURL(blob);
    let anchorTag = document.createElement("a");
    anchorTag.setAttribute("href", link);
    anchorTag.target = '_blank';
    document.body.appendChild(anchorTag);
    anchorTag.click();
    document.body.removeChild(anchorTag);
  }

  getInstructionFile(engagementId: number, surveyCategoryId: number): Observable<Blob> {
    const downloadFileUrl = API_URL.GETINSTRUCTIONSFILE + '?engagementId=' + engagementId + '&surveyCategoryId=' + surveyCategoryId;
    return this._sessionService.downloadAsFileGet(downloadFileUrl);
  }

  downloadErrorFile(errorFileRequest: ErrorFileRequest): void {
    this._sessionService.downloadAsFile(API_URL.DOWNLOAD_ERROR_FILE, errorFileRequest).subscribe(blobResponse => {
      if (blobResponse) {
        let filenameWithoutExtension = errorFileRequest.fileName.substring(0, errorFileRequest.fileName.lastIndexOf('.'));
        const fileName: string = filenameWithoutExtension + '-Error File' + '.xlsx';
        this.saveBlobToFile(blobResponse, fileName);
      }
    });
  }

  getImportFileStatus(engagementId: number, fileType: number, fileId: number = 0): Observable<FileImportStatus> {
    return this._sessionService.apiUrlGet(API_URL.GET_FILE_IMPORT_STATUS + '?engagementId=' + engagementId + '&fileType=' + fileType + '&fileId=' + fileId) as Observable<FileImportStatus>;
  }

}
